import { SET_GLOBAL, SET_GLOBAL_SUCCESS, ERASE_BUFFER_GLOBAL, ERASE_BUFFER_GLOBAL_SUCCESS } from './constants';

/**
 *
 * @param obj
 * @returns {{obj: *, type: string}}
 */
const setGlobal = ( obj ) => ( {
    type: SET_GLOBAL,
    obj
} );
/**
 *
 * @returns {{type: string}}
 */
const eraseBufferGlobal = () => ( {
    type: ERASE_BUFFER_GLOBAL
} );
/**
 *
 * @returns {{type: string}}
 */
const eraseBufferGlobalSucees = () => ( {
    type: ERASE_BUFFER_GLOBAL_SUCCESS
} );
/*

 */
const setGlobalsuccess = ( obj ) => ( {
    type: SET_GLOBAL_SUCCESS,
    obj
} );

export {
    setGlobal,
    setGlobalsuccess,
    eraseBufferGlobal,
    eraseBufferGlobalSucees
};